import React, { useState } from 'react';
import { all_routes } from '../../router/all_routes';
import { Link } from 'react-router-dom';
import ImageWithBasePath from '../../../core/common/imageWithBasePath';
import { useGetCourseWithSubjectNamesApiQuery } from '../../../core/Features/api/findACourse/studyAbroadCourses/studyAbroadCourses';
import useDebounce from '../../../core/common/hooks/useDebounce';



const data = [
    {
        title: 'Agriculture Sciences',
        subjects: [
            'Pest And Weed Control',
            'Plant Sciences',
            'Crop Sciences',
            'Horticulture and Viticulture',
            'Wool Science',
            'Animal Science',
            'Soil Science',
            'Agricultural Engineering',
            'Food Science Technology',
            'Veterinary Medicine',
            'Forestry',
            'Fisheries Science',
            'Agricultural Economics',
            'Plant Pathology',
            'Entomology',
            'Agronomy',
            'Dairy Science',
            'Poultry Science',
            'Agricultural Extension',
            'Seed Technology'
        ],
    },
    {
        title: 'Agriculture, Environmental & Rel Studies',
        subjects: [
            'Environmental Science',
            'Environmental Engineering',
            'Ecology',
            'Conservation Biology',
            'Sustainable Agriculture',
            'Climate Change Studies',
            'Environmental Policy',
            'Natural Resource Management',
            'Environmental Chemistry',
            'Environmental Microbiology',
            'Water Resources Management',
            'Pollution Control',
            'Environmental Impact Assessment',
            'Renewable Energy',
            'Green Technology',
            'Biodiversity Conservation',
            'Environmental Education',
            'Waste Management',
            'Atmospheric Science',
            'Marine Environmental Science'
        ],
    },
    {
        title: 'All Accounting',
        subjects: [
            'Financial Accounting',
            'Management Accounting',
            'Cost Accounting',
            'Auditing',
            'Taxation',
            'Corporate Finance',
            'Financial Management',
            'International Accounting',
            'Forensic Accounting',
            'Public Accounting',
            'Governmental Accounting',
            'Non-Profit Accounting',
            'Accounting Information Systems',
            'Financial Analysis',
            'Budget Planning',
            'Investment Analysis',
            'Risk Management',
            'Internal Controls',
            'Ethics in Accounting',
            'Advanced Financial Reporting'
        ],
    },
    {
        title: 'All Pharmacy',
        subjects: [
            'Pharmaceutical Chemistry',
            'Pharmacology',
            'Pharmaceutics',
            'Pharmacognosy',
            'Clinical Pharmacy',
            'Hospital Pharmacy',
            'Community Pharmacy',
            'Industrial Pharmacy',
            'Pharmaceutical Analysis',
            'Biopharmaceutics',
            'Pharmacokinetics',
            'Drug Discovery',
            'Drug Development',
            'Toxicology',
            'Medicinal Chemistry',
            'Pharmaceutical Biotechnology',
            'Regulatory Affairs',
            'Pharmaceutical Marketing',
            'Pharmacy Management',
            'Nuclear Pharmacy'
        ],
    },
    {
        title: 'Architecture and Planning',
        subjects: [
            'Architectural Design',
            'Urban Planning',
            'Urban Design',
            'Building Technology',
            'Construction Management',
            'Structural Engineering',
            'Environmental Design',
            'Landscape Architecture',
            'Interior Design',
            'Housing Studies',
            'Regional Planning',
            'Transportation Planning',
            'Sustainable Design',
            'Building Information Modeling',
            'Architectural History',
            'Real Estate Development',
            'Architectural Engineering',
            'Historic Preservation',
            'Smart Cities',
            'Green Building Design'
        ],
    },
    {
        title: 'Art and Design',
        subjects: [
            'Fine Arts',
            'Graphic Design',
            'Fashion Design',
            'Industrial Design',
            'Product Design',
            'Interior Design',
            'Visual Arts',
            'Digital Arts',
            'Animation',
            'Photography',
            'Textile Design',
            'Jewelry Design',
            'Ceramics',
            'Sculpture',
            'Painting',
            'Drawing',
            'Printmaking',
            'Art History',
            'Art Therapy',
            'Museum Studies',
            'Curatorial Studies',
            'Art Education',
            'Creative Writing',
            'Film Studies',
            'Game Design'
        ],
    },
    {
        title: 'Business and Management',
        subjects: [
            'Business Administration',
            'Marketing',
            'Human Resource Management',
            'Operations Management',
            'Strategic Management',
            'Entrepreneurship',
            'International Business',
            'Supply Chain Management',
            'Project Management',
            'Business Analytics',
            'E-commerce',
            'Digital Marketing',
            'Brand Management',
            'Sales Management',
            'Retail Management',
            'Business Law',
            'Organizational Behavior',
            'Business Ethics',
            'Quality Management',
            'Business Communication'
        ],
    },
    {
        title: 'Computer Science and IT',
        subjects: [
            'Programming',
            'Software Engineering',
            'Data Structures',
            'Algorithms',
            'Database Systems',
            'Computer Networks',
            'Cybersecurity',
            'Artificial Intelligence',
            'Machine Learning',
            'Data Science',
            'Web Development',
            'Mobile App Development',
            'Cloud Computing',
            'Internet of Things',
            'Computer Graphics',
            'Human-Computer Interaction',
            'Software Testing',
            'Information Systems',
            'Computer Architecture',
            'Blockchain Technology'
        ],
    },
    {
        title: 'Engineering',
        subjects: [
            'Mechanical Engineering',
            'Electrical Engineering',
            'Civil Engineering',
            'Chemical Engineering',
            'Computer Engineering',
            'Electronics Engineering',
            'Aerospace Engineering',
            'Industrial Engineering',
            'Biomedical Engineering',
            'Environmental Engineering',
            'Petroleum Engineering',
            'Materials Engineering',
            'Nuclear Engineering',
            'Marine Engineering',
            'Automotive Engineering',
            'Robotics Engineering',
            'Mining Engineering',
            'Textile Engineering',
            'Food Engineering',
            'Systems Engineering'
        ],
    },
    {
        title: 'Medicine and Health Sciences',
        subjects: [
            'General Medicine',
            'Surgery',
            'Pediatrics',
            'Obstetrics and Gynecology',
            'Cardiology',
            'Neurology',
            'Psychiatry',
            'Dermatology',
            'Orthopedics',
            'Anesthesiology',
            'Radiology',
            'Pathology',
            'Emergency Medicine',
            'Family Medicine',
            'Internal Medicine',
            'Oncology',
            'Ophthalmology',
            'ENT',
            'Urology',
            'Public Health'
        ],
    },
    {
        title: 'Nursing and Allied Health',
        subjects: [
            'General Nursing',
            'Pediatric Nursing',
            'Psychiatric Nursing',
            'Community Health Nursing',
            'Critical Care Nursing',
            'Medical-Surgical Nursing',
            'Obstetric Nursing',
            'Physiotherapy',
            'Occupational Therapy',
            'Speech Therapy',
            'Medical Laboratory Technology',
            'Radiology Technology',
            'Nutrition and Dietetics',
            'Health Education',
            'Medical Records',
            'Respiratory Therapy',
            'Dental Hygiene',
            'Paramedical Sciences',
            'Hospital Administration',
            'Health Informatics'
        ],
    },
    {
        title: 'Sciences',
        subjects: [
            'Physics',
            'Chemistry',
            'Biology',
            'Mathematics',
            'Statistics',
            'Geology',
            'Geography',
            'Astronomy',
            'Botany',
            'Zoology',
            'Microbiology',
            'Biochemistry',
            'Biophysics',
            'Genetics',
            'Molecular Biology',
            'Biotechnology',
            'Nanotechnology',
            'Materials Science',
            'Meteorology',
            'Oceanography'
        ],
    },
    {
        title: 'Social Sciences',
        subjects: [
            'Psychology',
            'Sociology',
            'Anthropology',
            'Political Science',
            'Economics',
            'International Relations',
            'Public Administration',
            'Social Work',
            'Criminology',
            'Development Studies',
            'Gender Studies',
            'Cultural Studies',
            'Urban Studies',
            'Rural Studies',
            'Population Studies',
            'Peace Studies',
            'Environmental Studies',
            'Migration Studies',
            'Media Studies',
            'Communication Studies'
        ],
    },
    {
        title: 'Humanities',
        subjects: [
            'History',
            'Philosophy',
            'English Literature',
            'Linguistics',
            'Languages',
            'Religious Studies',
            'Archaeology',
            'Classical Studies',
            'Medieval Studies',
            'Renaissance Studies',
            'Modern Studies',
            'Cultural Heritage',
            'Comparative Literature',
            'Translation Studies',
            'Creative Writing',
            'Rhetoric',
            'Ethics',
            'Aesthetics',
            'Logic',
            'Theology'
        ],
    },
    {
        title: 'Education',
        subjects: [
            'Elementary Education',
            'Secondary Education',
            'Higher Education',
            'Special Education',
            'Educational Psychology',
            'Educational Technology',
            'Curriculum Development',
            'Educational Administration',
            'Educational Research',
            'Distance Learning',
            'Adult Education',
            'Vocational Education',
            'Teacher Training',
            'Educational Assessment',
            'Educational Policy',
            'Comparative Education',
            'Educational Leadership',
            'Instructional Design',
            'Learning Sciences',
            'Educational Philosophy'
        ],
    },
    {
        title: 'Law',
        subjects: [
            'Constitutional Law',
            'Criminal Law',
            'Civil Law',
            'Corporate Law',
            'International Law',
            'Environmental Law',
            'Labor Law',
            'Tax Law',
            'Family Law',
            'Property Law',
            'Intellectual Property Law',
            'Human Rights Law',
            'Commercial Law',
            'Administrative Law',
            'Comparative Law',
            'Legal Research',
            'Legal Writing',
            'Ethics in Law',
            'Jurisprudence',
            'Legal History'
        ],
    },
    {
        title: 'Mass Communication and Media',
        subjects: [
            'Journalism',
            'Television Production',
            'Radio Production',
            'Digital Media',
            'Social Media',
            'Public Relations',
            'Advertising',
            'Media Ethics',
            'Media Law',
            'Documentary Production',
            'News Writing',
            'Feature Writing',
            'Photo Journalism',
            'Broadcast Journalism',
            'Online Journalism',
            'Media Research',
            'Media Planning',
            'Content Creation',
            'Media Management',
            'Communication Theory'
        ],
    },
    {
        title: 'Sports and Physical Education',
        subjects: [
            'Physical Education',
            'Sports Science',
            'Exercise Physiology',
            'Sports Psychology',
            'Sports Management',
            'Kinesiology',
            'Recreation',
            'Athletic Training',
            'Sports Medicine',
            'Fitness Training',
            'Yoga',
            'Martial Arts',
            'Swimming',
            'Athletics',
            'Team Sports',
            'Individual Sports',
            'Sports Nutrition',
            'Sports Coaching',
            'Adventure Sports',
            'Adaptive Sports'
        ],
    },
    {
        title: 'Hotel Management and Tourism',
        subjects: [
            'Hotel Management',
            'Tourism Management',
            'Hospitality Management',
            'Food and Beverage Management',
            'Front Office Management',
            'Housekeeping Management',
            'Event Management',
            'Travel and Tourism',
            'Culinary Arts',
            'Restaurant Management',
            'Resort Management',
            'Airline Management',
            'Tourism Marketing',
            'Sustainable Tourism',
            'Cultural Tourism',
            'Ecotourism',
            'Adventure Tourism',
            'Medical Tourism',
            'Tourism Policy',
            'Destination Management'
        ],
    },
    {
        title: 'Music and Performing Arts',
        subjects: [
            'Classical Music',
            'Contemporary Music',
            'Music Theory',
            'Music Composition',
            'Music Performance',
            'Music Education',
            'Music Therapy',
            'Dance',
            'Theater',
            'Drama',
            'Acting',
            'Direction',
            'Choreography',
            'Music Production',
            'Sound Engineering',
            'Musical Instruments',
            'Vocal Training',
            'Stage Management',
            'Costume Design',
            'Set Design'
        ],
    },
];


interface BannerProps {
    apiValues: any;
}



const Faq: React.FC<BannerProps> = ({ apiValues }) => {
    const [openIndex, setOpenIndex] = useState<number | null>(0);
    const [searchText, setSearchText] = useState<string>('');
    const debouncedSearchText = useDebounce(searchText, 500); // 500ms delay


    const { data, isLoading, isError } = useGetCourseWithSubjectNamesApiQuery({ "searchTextValue": debouncedSearchText });
    const apiValues2 = data?.data || {};


    const route = all_routes;


    const toggleAccordion = (index: number) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchText(e.target.value.toLowerCase());
    };

    return (
        <div className=" bg-gray-100 p-4">
            <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">

                {/* Left Side: Banner */}
                <div>
                    <ImageWithBasePath
                        className=""
                        source={apiValues?.leftSideImage}
                        alt="img"
                    />
                </div>

                {/* Right Side: Search + Accordion */}
                <div className="bg-white rounded-2xl p-6 shadow-lg">
                    <div className="mb-6">
                        <p className="text-sm text-[#EA1D2A] mb-2 font-medium underline">
                            {apiValues?.rightSideTitle}
                        </p>
                        <h2 className="text-3xl font-bold text-[#1D1753] mb-6">
                            {apiValues?.rightSideDescription}
                        </h2>

                        {/* Search Field */}
                        <div className="flex mb-8 w-full rounded-xl shadow-sm overflow-hidden border border-gray-200">
                            <input
                                type="text"
                                value={searchText}
                                onChange={handleSearch}
                                placeholder="Search for subjects by keywords"
                                className="flex-grow px-4 py-3 text-sm focus:outline-none bg-white"
                            />
                            {/* <button className="bg-[#EA1D2A] text-white w-10 h-10 rounded-md flex items-center justify-center m-2">
                                <span className="text-xl font-bold">→</span>
                            </button> */}
                        </div>

                    </div>

                    {/* Accordion List */}
                    <div className="space-y-3">

                        {

                            (Array.isArray(apiValues2) ? apiValues2 : []).map((category: any, index: number) => {


                                // {data.map((category, index) => {
                                const filteredSubjects = category.subjects
                                    ?.filter((sub: any) =>
                                        sub?.subjectName?.toLowerCase().includes(searchText.toLowerCase())
                                    )
                                    .map((sub: any, index: number) => ({
                                        ...sub,
                                        _id: sub?._id // or use crypto/random UUID if you need unique
                                    })) || [];


                                const isOpen = openIndex === index;

                                return (
                                    <div key={index} className="border border-gray-200 rounded-xl shadow-sm overflow-hidden">
                                        <div
                                            className="flex justify-between items-center px-6 py-4 cursor-pointer bg-gray-50 hover:bg-gray-100 transition-colors"
                                            onClick={() => toggleAccordion(index)}
                                        >
                                            <span className="font-semibold text-[#1D1753] text-lg">{category.courseName}</span>
                                            <span className="text-xl font-bold text-gray-600">
                                                {isOpen ? '×' : '+'}
                                            </span>
                                        </div>

                                        {isOpen && category.subjects.length > 0 && (
                                            <div className="px-6 py-4 bg-white border-t border-gray-100">
                                                <div className="flex flex-wrap gap-3">
                                                    {searchText
                                                        ?
                                                        filteredSubjects?.map((sub: any, subIndex: any) => (
                                                            // <Link to={`${route.individualSubject}/${sub._id}`}>

                                                                <div
                                                                    key={subIndex}
                                                                    className="group flex items-center gap-2 bg-[#FFEDEE] hover:bg-red-100 text-red-600 px-4 py-2 rounded-full  transition-colors text-sm font-medium"
                                                                >

                                                                    <span>{sub.subjectName}</span>
                                                                    <svg className="w-3 h-3 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                                                    </svg>

                                                                </div>
                                                            // </Link>
                                                        ))
                                                        : category.subjects?.map((sub: any, subIndex: any) => (
                                                            // <Link 
                                                            //   to={`${route.individualSubject}/${sub._id}?subjectId=${sub._id}&courseID=${category._id}&otherData=yourData`}
                                                            // >
                                                                
                                                                <div
                                                                    key={subIndex}
                                                                    className="group flex items-center gap-2 bg-[#FFEDEE] hover:bg-red-100 text-red-600 px-4 py-2 rounded-full  transition-colors text-sm font-medium"
                                                                >

                                                                    <span>{sub.subjectName}</span>
                                                                    <svg className="w-3 h-3 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                                                    </svg>

                                                                </div>
                                                            // </Link>
                                                        ))}
                                                    {filteredSubjects.length === 0 && searchText && (
                                                        <p className="text-gray-500 text-sm">No subjects match your search.</p>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                );

                                // })}

                            }) || []

                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Faq;